import(/* webpackMode: "eager" */ "/home/interim/frontend/app/about/history/page.tsx");
